"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _config = require("../config/config");

var TableSelection =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TableSelection, _Component);

  function TableSelection() {
    (0, _classCallCheck2.default)(this, TableSelection);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableSelection).apply(this, arguments));
  }

  (0, _createClass2.default)(TableSelection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          selection = _this$props.selection,
          children = _this$props.children;
      var count = selection && selection.count();
      var isFull = selection && selection.isFull();
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('table-selection', className, {
          'table-selection--active': count
        })
      }, _react.default.createElement("div", {
        className: "table-selection-bar-container"
      }, _react.default.createElement("div", {
        className: "table-selection-bar"
      }, (0, _config.__n)('SELECTED %d ROW', 'SELECTED %d ROWS', count), isFull && ' (' + (0, _config.__)('MAXIMUM') + ')')), _react.default.createElement("div", {
        className: "table-selection-content"
      }, children));
    }
  }]);
  return TableSelection;
}(_react.Component);

exports.default = TableSelection;
TableSelection.propTypes = process.env.NODE_ENV !== "production" ? {
  selection: _propTypes.default.object
} : {};